import type { Special } from '@/types';

export const specials: Special[] = [
  {
    id: '1',
    title: '星辰与远方：科幻电影特辑',
    subtitle: '在浩瀚宇宙中，寻找人类的答案',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20collection%20image%20of%20multiple%20starships%20and%20a%20glowing%20nebula%20in%20deep%20space%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20grand%20atmosphere&width=800&height=500&seq=special-cover-01&orientation=landscape',
    description:
      '从穿越虫洞的远征，到漂浮云端的幻想之城，本专题精选多部兼具想象力与人文关怀的科幻佳作，带你一起仰望星空、思考人类自己。',
    movieIds: ['1', '11', '23', '7', '19'],
  },
  {
    id: '2',
    title: '暗夜迷踪：悬疑烧脑精选',
    subtitle: '真相，往往藏在最不起眼的角落',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20cinematic%20collection%20image%20of%20a%20foggy%20city%20street%20at%20night%20with%20a%20lone%20figure%20and%20glowing%20lights%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20mysterious%20atmosphere&width=800&height=500&seq=special-cover-02&orientation=landscape',
    description:
      '当每一个细节都可能是线索，每一次呼吸都可能暴露真相。这个专题为你集结了最烧脑、最扣人心弦的悬疑惊悚电影。',
    movieIds: ['2', '8', '16', '5', '12'],
  },
  {
    id: '3',
    title: '人间烟火：温情剧情合辑',
    subtitle: '最动人的故事，往往发生在最平凡的生活里',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20collection%20image%20of%20a%20cozy%20house%20with%20glowing%20windows%20on%20a%20green%20mountain%20at%20dusk%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20heartwarming%20atmosphere&width=800&height=500&seq=special-cover-03&orientation=landscape',
    description:
      '有关家、有关陪伴、有关那些没能说出口的爱。这些温润如水的故事，会在某个瞬间，轻轻击中你的心。',
    movieIds: ['9', '20', '24', '15', '17'],
  },
  {
    id: '4',
    title: '炸裂肾上腺素：高燃动作特辑',
    subtitle: '当世界拉响警报，总有人挺身而出',
    cover: 'https://readdy.ai/api/search-image?query=High%20energy%20cinematic%20collection%20image%20of%20an%20explosive%20action%20scene%20with%20a%20helicopter%20and%20glowing%20sparks%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20thrilling%20atmosphere&width=800&height=500&seq=special-cover-04&orientation=landscape',
    description:
      '追车、爆破、以少敌多——本专题汇集最燃最爽的动作大片，为你的夜晚注入一剂强心针。',
    movieIds: ['2', '6', '14', '22', '18'],
  },
  {
    id: '5',
    title: '怦然心动：浪漫爱情精选',
    subtitle: '爱情的样子，值得被一遍遍讲述',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20cinematic%20collection%20image%20of%20two%20silhouettes%20under%20blossom%20trees%20at%20golden%20hour%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20tender%20atmosphere&width=800&height=500&seq=special-cover-05&orientation=landscape',
    description:
      '从校园里的暗恋，到跨越时空的重逢，这个专题收藏了那些让人心头一暖的爱情故事。',
    movieIds: ['3', '13', '7'],
  },
  {
    id: '6',
    title: '捧腹解压：爆笑喜剧专场',
    subtitle: '生活已经够累，不如一起大笑一场',
    cover: 'https://readdy.ai/api/search-image?query=Fun%20cinematic%20collection%20image%20of%20a%20joyful%20colorful%20living%20room%20party%20with%20confetti%20and%20laughing%20friends%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20upbeat%20atmosphere&width=800&height=500&seq=special-cover-06&orientation=landscape',
    description:
      '笑点密集、槽点十足，却总能在结尾收获一份温暖的感动。需要放松的时候，来这个专场准没错。',
    movieIds: ['4', '10', '17'],
  },
];